import React from 'react';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  description?: React.ReactNode;
  /** 작은 상단 라벨 (예: "관리자") */
  eyebrow?: string;
  /** 오른쪽 액션 영역. primary 버튼은 하나만 */
  actions?: React.ReactNode;
  className?: string;
}

/** 모든 페이지 최상단에 쓰는 공통 헤더. hero/그라데이션 대신 이것을 사용합니다. */
const PageHeader: React.FC<PageHeaderProps> = ({ title, description, eyebrow, actions, className = '' }) => (
  <header className={`ui-page-header ${className}`.trim()}>
    <div className="ui-page-header__text">
      {eyebrow && <p className="ui-page-header__eyebrow">{eyebrow}</p>}
      <h1 className="ui-page-header__title">{title}</h1>
      {description && <p className="ui-page-header__desc">{description}</p>}
    </div>
    {actions && <div className="ui-page-header__actions">{actions}</div>}
  </header>
);

export default PageHeader;
